import {ContactInfoFormState} from '@target-web/leadads-form-view';
import {formatDate} from 'utils/formatDate';
import {FullUserInfo} from 'utils/userInfoContext';
import {Lead} from './types/Lead';
import {LeadFormDataType} from './types/LeadForm';
import {LeadFormStateInner} from 'core/types';
import {captureMessage} from '@sentry/react';

interface GetLead {
    formState: LeadFormStateInner;
    leadForm: LeadFormDataType;
    userInfo: FullUserInfo;
    consentStatus: boolean;
    canSendSocialMediaProfile: boolean;
}

export const getLead = ({formState, leadForm, userInfo, consentStatus, canSendSocialMediaProfile}: GetLead): Lead => {
    const contactInfo = formState.contactInfo;

    const res: Lead = {
        form_id: leadForm.form_id,
        contact_info: (Object.keys(contactInfo) as Array<keyof ContactInfoFormState>).reduce<
            Partial<Record<keyof ContactInfoFormState, string>>
        >((acc, fieldName) => {
            const field = contactInfo[fieldName];

            // TRG-188166 - Убираем из отправки поле, если для пользователя оно недоступно
            if (fieldName === 'social_media_profile' && !canSendSocialMediaProfile) {
                return acc;
            }

            if (field) {
                const {value} = field;

                let preparedValue = value;

                if (fieldName === 'phone') {
                    if (field.isFilled) {
                        preparedValue = String(value).replace(/[^0-9+]/g, ''); // бек принимает только цифры с опциональным плюсом вначале
                    } else {
                        preparedValue = '7' + value; // добавляем семерку вначале
                    }
                } else if (fieldName === 'birth_date') {
                    preparedValue = formatDate(String(value));
                }

                if (preparedValue) {
                    acc[fieldName] = preparedValue;
                }
            }

            return acc;
        }, {}),
        answers: Object.keys(formState.answers).map((blockId) => {
            const {value} = formState.answers[blockId];

            return {
                block_id: blockId,
                ...value,
            };
        }),
    };

    // добавляем хеш если поле заполнено и хеш есть
    if (
        leadForm.contact_fields.includes('phone') &&
        formState.contactInfo?.phone?.isFilled &&
        formState.contactInfo.phone.hash
    ) {
        res.contact_info.phone_hash = formState.contactInfo.phone.hash;
        if (!userInfo.phone_data) {
            captureMessage('phone_data is required', 'error');
        }
        res.phone_data = userInfo.phone_data;
    }

    // добавляем хеш если поле заполнено и хеш есть
    if (
        leadForm.contact_fields.includes('email') &&
        formState.contactInfo?.email?.isFilled &&
        formState.contactInfo.email.hash
    ) {
        res.contact_info.email_hash = formState.contactInfo.email.hash;
        if (!userInfo.email_data) {
            captureMessage('email_data is required', 'error');
        }
        res.email_data = userInfo.email_data;
    }

    if (leadForm.ads_consent_url) {
        res.consent_status = consentStatus;
    }

    return res;
};
